import type { Module } from 'vuex';
import { PriceExchange } from '@/types/PriceExchange';
import {RootState} from "@/store";

export interface PriceExchangeState {
  priceExchange: PriceExchange | null;
  deleted: boolean;
}

const priceExchangeModule: Module<PriceExchangeState, RootState> = {
  namespaced: true,

  state: (): PriceExchangeState => ({
    priceExchange: null,
    deleted: false,
  }),

  mutations: {
    setPriceExchange(state, payload: { indexExchange: number; code: string; }) {
      state.priceExchange = new PriceExchange(
        payload.indexExchange,
        payload.code,
      );
      state.deleted = false;
    },
    clearPriceExchange(state) {
      state.priceExchange = null;
      state.deleted = false;
    },
  },

  actions: {
    wsSetPriceExchange({ commit }, payload) {
      commit('setPriceExchange', payload);
    },
    clearPriceExchange({ commit }) {
      commit('clearPriceExchange');
    },
    wsSetEmptyPriceExchange({ commit }) {
      commit('clearPriceExchange');
    },
  },
};

export default priceExchangeModule;
